/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { LoginContentByPass } from "../components/container/login/content-bypass";
import Loading from "../components/loading/loading";
import { RoleStatus } from "../shared/Enum/RoleStatus";

import { selectUserProfile, selectUserRole } from "../store/auth/selector";
import { getAuthToken } from "../utils/storage";

export function Bypass() {
  const navigate = useNavigate();
  const authToken = getAuthToken();
  const userProfile = useSelector(selectUserProfile);
  const userRole = useSelector(selectUserRole);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    if (!authToken) {
      navigate("/login", { replace: true });
      return;
    }

    if (!userProfile || !userRole) {
      return;
    }

    const isAdmin =
      userRole.roleId === RoleStatus.toId(RoleStatus.Administrator);
    const isBypassNull = userProfile.BypassActorBinusianId == null;
    const shouldRedirectToHome = !(isAdmin && isBypassNull);

    if (shouldRedirectToHome) {
      navigate("/", { replace: true });
      return;
    }

    setLoading(false);
  }, []);

  if (loading) {
    return <Loading open />;
  }

  return <LoginContentByPass />;
}
